import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import Home from "./pages/Home";
import Clients from "./pages/Clients";
import Detailers from "./pages/Detailers";

// The portal pulls in leaflet (JS + CSS), which no public page needs. Splitting
// it out keeps it off the critical path for everyone who never signs in.
const Portal = lazy(() => import("./pages/portal/Portal"));

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/detailers" element={<Detailers />} />
      <Route
        path="/portal"
        element={
          <Suspense fallback={null}>
            <Portal />
          </Suspense>
        }
      />
    </Routes>
  );
}
